<template>
  <div id="app">

  </div>
</template>

<script>
  import Utils from "./service/ServiceUtils";
  import ServiceDialog from "./service/ServiceDialog";
  import ServiceUtils from "./service/ServiceUtils"
  import Http from "./service/ServiceHttp"


  export default {
      name: 'AppTest',
      methods: {
          openTakoutSet() {
              ServiceUtils.config.sellerId="21cad17f3c25444fa64e91b664551fc5";
              ServiceUtils.config.storeId = "S1";
              Http.getSellerTakeoutConfig(res => {
                  if (res && res.length > 0) {
                      ServiceDialog.OpenUserTakeoutSet(res[0],res => {
                          config.log("res::", res);
                      });
                  }
              })
          },
          openAlert(){
              ServiceDialog.showAlert("温馨提示","本地已打烊！");
          }
      },

      created() {
          Http.testLogin();
      },
      mounted() {
          this.openTakoutSet();
      }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/AppTest.vue